import * as React from "react";
import * as kea from "kea-react";
import { history, fechaCarga } from "app/main/std";
interface State { error: any }


export class ErrorBoundary extends React.Component<{}, State> {
    constructor(props) {
        super(props);
        this.state = { error: undefined };
    }

    static getDerivedStateFromError(error): State {
        // Update state so the next render will show the fallback UI.
        return { error: error || "" };
    }

    onRegresar = async () => {
        await history.goBack();
        location.reload(true);
    }

    render() {
        if (this.state.error) {
            // You can render any custom fallback UI
            return (
                <div className="container-fluid">
                    <h2></h2>
                    <kea.Title titulo="Ha ocurrido un problema al dibujar la página :(" onRegresar={this.onRegresar} />
                    <h6>Por favor facilite la siguiente información a desarrollo:</h6>
                    <hr />
                    <label>
                        Ruta:
                    </label>
                    <pre>
                        {window.location.hash}
                    </pre>
                    <label>
                        Mensaje de error:
                    </label>
                    <pre>
                        {"" + this.state.error}
                    </pre>
                    <label>
                        Fecha de carga / hoy
                    </label>
                    <pre>
                        {fechaCarga.toLocaleString() + " / " + new Date().toLocaleString()}
                    </pre>
                    <label>
                        Stack trace:
                    </label>
                    <pre>
                        {"" + this.state.error.stack}
                    </pre>
                    <label>
                        Sesión:
                    </label>
                    <pre>
                        {localStorage.getItem("Authorization")}
                    </pre>
                    <label>
                        LocalStorage:
                    </label>
                    <pre>
                        {JSON.stringify(localStorage, null, 3)}
                    </pre>
                </div>
            );
        }

        return this.props.children;
    }
}




// WEBPACK FOOTER //
// ./app/features/inicio/error.tsx